
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Capa 2"}},[_c('g',{attrs:{"fill":"#8c9091","data-name":"Capa 1"}},[_c('path',{attrs:{"d":"M16 24h8v16h-8zM24 16h8v8h-8zM8 16h8v8H8zM32 0H0v16h8V8h24v8h8V0h-8z"}})])])])
          )
        }
      }
    